import { Flex, Text, IconButton, Tooltip } from "@chakra-ui/react";
import { useState, useRef, useEffect } from "react";
import DeleteIcon from "@root/assets/icons/deleteicon";
import {
  DeleteIconContainer,
  DocumentStack,
  LabelContainer,
} from "@root/components/dashboard/style";
import { addLabelsAndColors } from "@root/utils";
import { CommonTooltip } from "@root/components/common/tooltip";

interface AttachedFile {
  id: string;
  fileName: string;
  [key: string]: any;
}

interface AttachedFilesListProps {
  files: AttachedFile[];
  onDelete?: (fileId: string) => void;
  containerProps?: any;
  itemProps?: any;
}

export const AttachedFilesList: React.FC<AttachedFilesListProps> = ({
  files,
  onDelete,
  containerProps = {},
  itemProps = {},
}) => {
  const [hoveredItem, setHoveredItem] = useState<AttachedFile | null>(null);
  const documents = addLabelsAndColors(files || []);

  if (!documents || documents.length === 0) {
    return null;
  }

  return (
    <Flex
      overflowX="auto"
      overflowY="hidden"
      mx={"2"}
      minW="0"
      flex="1 1 auto"
      {...containerProps}
    >
      {documents.map((doc: any) => (
        <Flex
          key={doc.id}
          position="relative"
          gap={"8px"}
          cursor={"pointer"}
          _hover={{ bgColor: "white" }}
          p={"7px 12px"}
          borderRadius={"md"}
          onMouseEnter={() => setHoveredItem(doc)}
          onMouseLeave={() => setHoveredItem(null)}
          flexShrink={0}
          minW="fit-content"
          alignItems="center"
          {...itemProps}
        >
            <CommonTooltip label={doc?.fileName}>
          <DocumentStack flexShrink={0}>
            <LabelContainer
              color={`${doc.colorScheme}.400`}
              borderColor={`${doc.colorScheme}.400`}
              flexShrink={0}
            >
              {doc?.label}
            </LabelContainer>
              <Text
                fontSize="sm"
                whiteSpace="nowrap"
                flexShrink={0}
                maxW="200px"
                overflow="hidden"
                textOverflow="ellipsis"
              >
                {doc?.fileName_key || doc?.fileName}
              </Text>
          </DocumentStack>
            </CommonTooltip>

          {onDelete && doc?.id === hoveredItem?.id && (
            <DeleteIconContainer alignSelf={"center"} flexShrink={0} ml="4px">
              <Tooltip label="Delete" hasArrow>
                <IconButton
                  icon={<DeleteIcon boxSize={5} />}
                  size="xs"
                  aria-label="Delete"
                  variant="ghost"
                  colorScheme="red"
                  onClick={(e) => {
                    e.stopPropagation();
                    onDelete(doc.id);
                  }}
                />
              </Tooltip>
            </DeleteIconContainer>
          )}
        </Flex>
      ))}
    </Flex>
  );
};
